module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stacked-bar-placeholder"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-47b3a8d5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dataVisualization/d3js/horizontalStackedBar.vue
// module id = 1721
// module chunks = 61